import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import styles from '../../styles/Products.module.scss';
import '../../styles/slick.scss';
import '../../styles/slick-theme.scss';
import { assetUrl } from '../../utils/imageUrl';
import { getFirstWholesaleTier, hasDiscount, hasWholesaleTiers } from '../../utils/productPrice';
import CarouselNav from '../common/CarouselNav';
import useViewedProducts from '../../hooks/useViewedProducts';

const TITLE = 'Ви переглядали';

const ProductCard = ({ product }) => {
  const { id, images, title, price, oldPrice, article } = product;
  const cat = product.category?.name;
  const wholesaleTier = getFirstWholesaleTier(product);

  return (
    <Link to={`/products/${id}`} className={styles.product}>
      <div className={styles.image}>
        <img src={assetUrl(images[0])} alt={title} />
      </div>
      <div className={styles.wrapper}>
        <h3 className={styles.title}>{title}</h3>
        {article && <div className={styles.article}>Артикул: {article}</div>}
        <div className={styles.cat}>{cat}</div>
        <div className={styles.info}>
          <div className={styles.prices}>
            <div className={styles.priceRow}>
              <div className={styles.price}>{price}₴</div>
              {hasDiscount(price, oldPrice) && (
                <div className={styles.oldPrice}>{oldPrice}₴</div>
              )}
            </div>
            {hasWholesaleTiers(product) && wholesaleTier && (
              <div className={styles.wholesale}>
                від {wholesaleTier.minQty} шт. — {wholesaleTier.price}₴
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

const ViewedProducts = () => {
  const products = useViewedProducts();
  const sliderRef = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);

  const count = products.length;
  const slidesToShow = Math.min(4, count);
  const useCarousel = count > slidesToShow;
  const pageCount = useCarousel ? count - slidesToShow + 1 : 0;

  if (count === 0) {
    return null;
  }

  const settings = {
    dots: false,
    infinite: useCarousel,
    speed: 500,
    slidesToShow: slidesToShow || 1,
    slidesToScroll: 1,
    autoplay: count > 1,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
    beforeChange: (_current, next) => setSlideIndex(next),
  };

  const items = products.map((product) => (
    <div key={product.id} className={styles.slide}>
      <ProductCard product={product} />
    </div>
  ));

  return (
    <section
      className={`${styles.products} productsFullBleed${useCarousel ? ` ${styles.productsCarousel}` : ''}`}
    >
      <h2>{TITLE}</h2>
      {useCarousel ? (
        <>
          <div className={styles.sliderWrap}>
            <Slider ref={sliderRef} {...settings}>{items}</Slider>
          </div>
          <CarouselNav
            total={pageCount}
            current={Math.min(slideIndex, pageCount - 1)}
            onPrev={() => sliderRef.current?.slickPrev()}
            onNext={() => sliderRef.current?.slickNext()}
            onDotClick={(index) => sliderRef.current?.slickGoTo(index)}
          />
        </>
      ) : (
        <div className={styles.list}>
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ViewedProducts;
